module.exports = __webpack_public_path__ + "media/images/icons/page_join-ec57a08ec7e753d12908081b16075666.svg";